var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[(this.$route.name === 'Core')?_c('DrawerSkills'):_vm._e(),_c('router-view'),_c('notifications',{attrs:{"position":"bottom right","type":"warn"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }